var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12318_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4022 27.4463C66.0167 25.1378 79.103 32.7901 83.5223 45.6367C88.2076 59.2504 80.8821 74.4891 67.1825 79.5947C63.7208 80.8846 60.2255 81.4375 55.4745 81.4375H55.4735C46.5856 81.1031 38.7475 76.5826 33.4012 68.6846C33.1415 68.3005 33.0223 67.9856 33.0048 67.7148C32.99 67.4853 33.046 67.2619 33.1923 67.0273L33.2606 66.9258C33.5192 66.567 33.8321 66.4054 34.1298 66.4053C34.2472 66.4053 34.3709 66.4295 34.4999 66.4824H34.5009C34.8818 66.637 35.3188 67.0092 35.6483 67.4951C39.6168 73.3459 45.0538 77.0077 51.7968 78.3643V78.3652C58.0475 79.6221 64.4692 78.6209 69.8788 75.5439C75.2821 72.4712 79.3164 67.5375 81.2343 61.6514V61.6504C83.296 55.3185 82.5729 48.2878 79.2528 42.3604C75.9307 36.4268 70.276 32.0789 63.7401 30.4336C58.3156 29.0663 52.8145 29.3415 47.8378 31.2344C42.8589 33.1273 38.6168 36.5576 35.5682 41.1504C35.2617 41.6117 34.9154 41.8859 34.5819 41.998C34.2566 42.1073 33.9163 42.0723 33.5819 41.8643C33.2797 41.675 33.1014 41.4263 33.0389 41.1484H33.0399C32.9599 40.7843 33.0582 40.3311 33.3915 39.8301C37.9509 32.9776 44.3428 28.8144 52.4022 27.4463Z",
    fill: "white",
    stroke: "#001937",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2444 40.5308C52.6761 40.5308 53.1077 40.5312 53.5374 40.5317C53.9671 40.5323 54.3956 40.5327 54.8206 40.5327C56.5428 40.5348 58.2653 40.5348 59.9875 40.5327C61.8358 40.5306 63.7986 40.5292 65.7024 40.5396H65.7737C70.1127 40.5984 73.3764 43.8486 73.3967 48.1323C73.4156 52.263 73.4156 56.3775 73.3967 60.3608C73.3752 64.5361 70.2765 67.7244 66.1018 67.9341L65.6946 67.9448C60.0937 67.9635 54.5094 67.9635 49.0999 67.9448C44.7282 67.9286 41.4315 64.6657 41.4133 60.3491C41.3944 56.1851 41.3944 52.0708 41.4133 48.1206C41.4336 43.8236 44.7339 40.5636 49.1135 40.5396H49.1145C50.1516 40.5313 51.2015 40.5308 52.2444 40.5308ZM53.4778 48.7886H61.3049V43.1313H53.4778V48.7886ZM50.8733 43.2134L50.6038 43.186L50.1331 43.1392H50.134C48.3401 42.9498 46.7104 43.3787 45.5657 44.3862C44.5341 45.2931 43.9913 46.5651 43.9758 48.0415C43.9338 52.1835 43.9338 56.3777 43.9758 60.5073C44.005 63.2851 46.1426 65.4014 48.9348 65.4214C51.6775 65.4421 54.5128 65.4526 57.3606 65.4526C60.2084 65.4526 63.073 65.4421 65.8704 65.4214C68.5434 65.4022 70.625 63.4824 70.8059 60.9058H70.8176L70.8215 60.6099C70.8889 55.6208 70.8863 51.5561 70.8147 47.8228C70.7874 46.4414 70.1805 45.1628 69.1399 44.2769L68.926 44.105C67.7006 43.1764 66.1077 42.8643 64.5647 43.2417L64.1672 43.3384L63.9387 43.395V45.7495C63.9408 47.067 63.9401 48.3883 63.9338 49.7114C63.9308 50.4012 63.8002 50.78 63.5745 50.9985C63.3462 51.2191 62.9502 51.3461 62.2366 51.3472H62.2356C59.0297 51.3555 55.7776 51.3555 52.5696 51.3472C51.8567 51.3451 51.4608 51.2178 51.2327 50.9966C51.0351 50.8049 50.9102 50.4903 50.8801 49.9517L50.8733 49.7075V43.2134Z",
    fill: "white",
    stroke: "#001937",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9924 46.7661C33.5133 46.7699 33.9223 46.9324 34.1741 47.189H34.175C34.3593 47.3765 34.4687 47.6223 34.4875 47.9165L34.4905 48.0464C34.4818 48.4273 34.3381 48.7193 34.0989 48.9214C33.8547 49.1277 33.4844 49.2625 32.9924 49.269C32.1458 49.2794 31.2735 49.277 30.426 49.2749H27.72C26.8401 49.277 25.9369 49.2814 25.0422 49.269C24.5186 49.2616 24.1041 49.0951 23.8518 48.8364V48.8354L23.7776 48.7524C23.6168 48.5506 23.5328 48.2919 23.5403 47.9868C23.5499 47.6003 23.6941 47.307 23.9319 47.106C24.1745 46.9009 24.5423 46.7689 25.0315 46.7661C26.3291 46.7578 27.6478 46.7534 28.9778 46.7534L32.9924 46.7661Z",
    fill: "white",
    stroke: "#001937",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8494 52.978L33.1404 52.9956C33.9515 53.0116 34.49 53.5485 34.49 54.2397V54.2407C34.4915 54.9324 33.9702 55.4612 33.1355 55.4897C32.5419 55.5102 31.9181 55.5047 31.3591 55.5005C31.088 55.4984 30.8048 55.4966 30.5427 55.4966C30.2808 55.4966 30.017 55.4984 29.7566 55.5005H29.6892C29.1478 55.5046 28.5926 55.5082 28.0554 55.4897C27.2176 55.4611 26.6941 54.9312 26.6941 54.2417C26.6941 53.8746 26.8313 53.5725 27.0574 53.3589C27.2566 53.1708 27.5375 53.0396 27.8835 53.0044L28.0359 52.9956C29.2821 52.9723 30.5604 52.9664 31.8494 52.978Z",
    fill: "white",
    stroke: "#001937",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7122 59.2104C33.1428 59.2115 33.5832 59.2736 33.9153 59.4526C34.1877 59.5995 34.3964 59.8285 34.467 60.2114L34.4885 60.3862C34.5119 60.7158 34.4401 60.9655 34.2952 61.1548L34.2288 61.2329C33.9357 61.5399 33.3905 61.7331 32.5774 61.7231H32.5764C31.9325 61.7174 31.4538 61.53 31.1819 61.2466L31.1692 61.2329C30.9704 61.016 30.8713 60.7227 30.9026 60.3628V60.3618C30.9369 59.9674 31.0946 59.6983 31.3625 59.5171C31.6448 59.3263 32.0829 59.2105 32.7122 59.2104Z",
    fill: "white",
    stroke: "#001937",
    strokeWidth: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_383",
    x: 13.0116,
    y: 118.476,
    width: 82.4529,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_383",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12318_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 55,
    fill: "white",
    transform: "translate(23.238 26.7378)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew7);
export default __webpack_public_path__ + "static/media/new-7.c513097470cddf56f39a0a89756579fc.svg";
export { ForwardRef as ReactComponent };